import { render, staticRenderFns } from "./CompanyChangeDetail.vue?vue&type=template&id=6be1f460&"
import script from "./CompanyChangeDetail.vue?vue&type=script&lang=js&"
export * from "./CompanyChangeDetail.vue?vue&type=script&lang=js&"
import style0 from "./CompanyChangeDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports